export default __webpack_public_path__ + "static/media/video.e038b670.svg";